import { skipThemeCleanupOnce } from "@hooks/useSetTheme";

type Props = {
  message?: string;
  handleExit: (any?) => void;
};
function exitBrowserAlert({ message, handleExit }: Props) {
  if (
    confirm(
      message || '페이지를 나가시겠습니까? 작성중인 글이 저장되지 않습니다.',
    )
  ) {
    skipThemeCleanupOnce();
    handleExit();
  } else {
    return;
  }
}

export default exitBrowserAlert;
